<script setup lang="ts">
useDefaultMeta()

const faqs = [
  {
    question:
      'Apa yang dimaksud dengan aplikasi kirim paket COD multi ekspedisi?',
    answer:
      '<p>Aplikasi kirim paket COD multi ekspedisi adalah platform digital yang memfasilitasi pengiriman barang melalui berbagai layanan ekspedisi terpercaya di Indonesia. Umumnya aplikasi kirim paket COD multi ekspedisi ini disediakan oleh aggregator logistik.</p>'
  },
  {
    question: 'Apa itu aggregator logistik?',
    answer:
      '<p>Aggregator logistik adalah wadah digital yang berfungsi mengintegrasikan berbagai layanan ekspedisi dari sejumlah perusahaan logistik Indonesia.<br/>Aggregator logistik memudahkan para online seller mengakses serta memanfaatkan berbagai jasa pengiriman dalam satu aplikasi atau situs web.</p>'
  },
  {
    question: 'Apa tujuan dari aggregator logistik?',
    answer:
      '<p>Tujuan utama aggregator logistik adalah memudahkan dan mempercepat proses atau sistem pengiriman barang bagi para online seller/individu. Aggregator logistik menyediakan akses ke berbagai layanan ekspedisi unggulan dalam satu aplikasi.</p>'
  },
  {
    question:
      'Apakah KiriminAja adalah jasa ekspedisi, jasa kurir, jasa pengiriman & jasa cargo?',
    answer:
      '<p>KiriminAja adalah platform yang berfungsi sebagai aggregator logistik. Artinya, KiriminAja menggabungkan berbagai jasa ekspedisi, jasa kurir, jasa pengiriman dan jasa cargo dalam satu aplikasi untuk memudahkan proses pengiriman para penjual online di Indonesia.</p>'
  },
  {
    question: 'Apa manfaat dari penggunaan aplikasi kirim paket KiriminAja?',
    answer:
      '<p><ul><li>Aplikasi KiriminAja memudahkan pengelolaan pengiriman.</li><li>KiriminAja menawarkan fitur-fitur inovatif yang dirancang untuk memudahkan proses pengiriman.</li><li>Mendapatkan akses ke dukungan pelanggan yang responsif dan handal.</li></ul>Secara keseluruhan, KiriminAja berperan sebagai mitra bisnis andalan bagi online seller Indonesia. Sehingga mampu mengelola pengiriman barang dengan lebih efisien dan efektif.</p>'
  },
  {
    question: 'Siapa saja yang bisa mendaftar di KiriminAja?',
    answer:
      '<p>Pemilik bisnis, online seller, dropshipper, reseller atau seseorang yang baru memulai bisnis online bisa mendaftar dan memanfaatkan berbagai fitur serta layanan KiriminAja.</p>'
  },
  {
    question: 'Bagaimana cara kirim barang via KiriminAja?',
    answer:
      '<p>Mengirim barang melalui KiriminAja adalah proses yang dirancang untuk menjadi sebisa mungkin mudah dan efisien. Berikut adalah langkah-langkah dasar yang bisa kamu ikuti saat mengirim barang dengan KiriminAja </p><ul><li>Pendaftaran</li><li>Pemilihan Layanan Pengiriman</li><li>Pengisian Detail Pengiriman</li><li>Pembayaran</li><li>Pengiriman Barang</li><li>Pelacakan Pengiriman</li></ul>'
  },
  {
    question:
      'Apa saja fitur yang tersedia pada Aplikasi Kirim Paket KiriminAja?',
    answer:
      '<p>Aplikasi kirim paket KiriminAja memiliki berbagai fitur yang dirancang untuk memudahkan dan mempercepat proses pengiriman barang. Berikut adalah beberapa fitur utama yang tersedia di KiriminAja: </p><ul><li>Integrasi dengan Berbagai Jasa Pengiriman</li><li>Pengiriman COD (Cash on Delivery) dan layanan COD Advance</li><li>Pelacakan Pengiriman Real-Time</li><li>Customer service yang Responsif</li><li>Plugin WooCommerce</li></ul>'
  },
  {
    question:
      'Apakah KiriminAja menyediakan layanan pengiriman paket ke luar negeri?',
    answer:
      '<p>Saat ini KiriminAja belum menyediakan fitur dan layanan ekspedisi antar negara untuk kirim paket ke luar negeri.</p>'
  },
  {
    question: 'Mana sajakah area jangkauan KiriminAja?',
    answer:
      '<p>Sebagai aggregator logistik yang menyediakan banyak jasa ekspedisi, area jangkauan KiriminAja meliputi ekspedisi antar kota, antar provinsi, dan antar pulau baik pengiriman darat dan laut.</p>'
  },
  {
    question:
      'Apakah aggregator logistik KiriminAja juga tersedia dalam versi Desktop/PC?',
    answer:
      '<p>Iya, KiriminAja, sebagai aplikasi kirim paket COD #1 Indonesia, bisa diakses melalui desktop atau PC. Kami percaya beragam kebutuhan pengguna harus difasilitasi demi kemudahan akses sistem logistik dan pertumbuhan bisnis pengguna.</p>'
  },
  {
    question: 'Apakah KiriminAja gratis?',
    answer:
      '<p>Menggunakan aplikasi KiriminAja untuk mendaftar dan mengakses sejumlah fitur dasar memang gratis. Namun, kamu juga perlu memahami bahwa untuk aktivitas mengirim paket, akan dikenakan biaya layanan tambahan.</p> </br> <p>Sebagai aplikasi kirim paket COD terbaik, KiriminAja menghadirkan berbagai jasa pengiriman supaya kamu bisa memilih ekspedisi barang dengan harga kirim paket termurah. Mulai dari kirim barang instan, berat, lewat cargo dsb.</p>'
  },
  {
    question:
      'Di mana bisa mendapatkan info terkait program dan promo terbaru dari KiriminAja?',
    answer:
      '<p>Untuk mendapatkan informasi terkini mengenai program dan kode promo/ kode voucher terbaru dari KiriminAja, kamu dapat mengunjungi beberapa sumber resmi yang disediakan oleh KiriminAja.</p> </br> <p>Berikut adalah beberapa cara atau sumber informasi terkini KiriminAja yang dapat kamu akses:</p> <ul><li>Situs Website Resmi</li><li>Media Sosial (Facebook, YouTube, Instagram, TikTok)</li><li>Aplikasi Mobile</li></ul>'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HomeHero />
    <div
      class="relative pb-1 lg:pb-80 xl:pb-32 bg-gradient-to-t from-surface-container-low"
    >
      <HomeCekOngkir />
    </div>
    <HomeLatestPromo />
    <HomeBenefit />
    <HomeSolusiPengiriman />
    <HomeCodFast />
    <HomeSupport />
    <PresetClients />
    <FaqBase :faqs="faqs" />
    <CtaSection />
  </div>
</template>
